import { inject, Injectable } from '@angular/core';
import { fromEvent } from 'rxjs';
import { filter } from 'rxjs/operators';

import { LocalStorageConstants } from '@auth/constants/local-storage-constants';
import { User } from '@auth/models/user';
import { TokenService } from '@auth/services/token.service';
import { UserStoreService } from '@auth/store/services/user-store.service';

@Injectable({ providedIn: 'root' })
export class SyncLoginStateService {
    private isInit = false;
    private readonly userStoreService = inject(UserStoreService);

    public initialize(): void {
        if (this.isInit) {
            return;
        }

        this.isInit = true;

        fromEvent<StorageEvent>(window, 'storage')
            .pipe(filter(event => event.key === LocalStorageConstants.TokenKey))
            .subscribe(({ newValue }) => {

                if (newValue == null) {
                    this.userStoreService.logout(true, true);

                    return;
                }

                const user: User = TokenService.restoreCurrentUser();

                this.userStoreService.confirmLogin(user, true);
            });
    }
}